import { computed } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cfc3642e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "en"
};
export default {
  __name: 'topTitle',
  props: ["title", "titleEn", "bgUrl"],
  setup(__props) {
    const props = __props;
    const topStyle = computed(() => {
      return {
        "background-image": `url(${props.bgUrl})`
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "top",
        style: _normalizeStyle(_unref(topStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title), 1), _createElementVNode("h2", null, _toDisplayString(__props.titleEn), 1)])], 4);
    };
  }
};